import { legacyLocalLabel, legacyLocalDate } from '../../../../utilities/legacyDatePresentation';
import { startOfDay } from 'date-fns';
import React from 'react';
import { CalendarX2 } from 'lucide-react';
import { AllEvent } from '../../../../interfaces/identity/calendar/Events';

interface HeaderCalendarEventsProps {
    selectedDate: Date | null;
    events: AllEvent[];
    isOpen: boolean;
    onEventClick: (event: AllEvent) => void;
}

export default function HeaderCalendarEvents({ selectedDate, events, isOpen, onEventClick }: HeaderCalendarEventsProps) {
    const dayEvents = selectedDate 
        ? events.filter(e => (+startOfDay(legacyLocalDate(e.startTime)) === +startOfDay(selectedDate)))
        : [];

    return (
        <div className={`bg-gray-50/80 dark:bg-slate-800/80 flex flex-col shrink-0 overflow-hidden transition-all duration-300 [transition-timing-function:cubic-bezier(0.34,1.56,0.64,1)] ${
            isOpen ? 'w-[260px] border-r border-gray-100 dark:border-slate-700 opacity-100' : 'w-0 border-r-0 opacity-0'
        }`}>
            <div className="w-[260px] h-[320px] flex flex-col">
                <div className="dark-surface p-4 border-b border-gray-100 dark:border-slate-700 shrink-0 bg-white dark:bg-slate-900">
                    <h4 className="text-sm font-bold text-gray-800 m-0 uppercase tracking-widest text-[11px] text-[#7E57C2]">
                        {selectedDate ? legacyLocalLabel(selectedDate, "EEEE, MMM dd") : ''}
                    </h4>
                </div>
                
                <div className="flex-1 overflow-y-auto p-3 space-y-2.5 custom-scrollbar">
                    {dayEvents.length === 0 ? (
                        <div className="h-full flex flex-col items-center justify-center text-gray-400 opacity-70">
                            <CalendarX2 size={24} className="mb-2" />
                            <p className="text-xs font-semibold m-0">No events scheduled</p>
                        </div>
                    ) : (
                        dayEvents.map(e => (
                            <div 
                                key={e.id} 
                                onClick={() => onEventClick(e)}
                                className="dark-surface dark-border-subtle bg-white dark:bg-slate-900 p-3 rounded-xl border border-gray-100 shadow-sm hover:border-purple-200 dark:hover:border-purple-400/40 transition-colors cursor-pointer"
                            >
                                <div className="text-[10px] font-bold text-[#7E57C2] mb-1 leading-none">
                                    {legacyLocalLabel(e.startTime, "h:mm a", true)} - {legacyLocalLabel(e.endTime, "h:mm a", true)}
                                </div>
                                <div className="text-[13px] font-semibold text-gray-800 dark:text-slate-100 leading-tight">
                                    {e.title}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}
